import { ProjectGeometryLock } from '../../types/drawing';
import { JobStatus, Project } from '../../types/project';

const running = (status?: JobStatus) => status === JobStatus.SCHEDULED || status === JobStatus.IN_PROGRESS;
/** The version's results belong to the geometry once its calculation is running or done. */
const calculated = (v: Project['versions'][number]) =>
  running(v.calculationJob?.jobStatus) || v.calculationJob?.jobStatus === JobStatus.COMPLETED;

/**
 * Why a project's geometry cannot change now (same rule as the backend): once a calculation is
 * running or done its results belong to this geometry; autopositioning places luminaires on it.
 */
export function projectGeometryLock(project: Pick<Project, 'versions'> | null | undefined): ProjectGeometryLock | null {
  const versions = project?.versions ?? [];
  if (versions.some(calculated)) return 'calculation';
  if (versions.some((v) => running(v.autopositioningJob?.jobStatus))) return 'autopositioning';
  return null;
}

export const GEOMETRY_LOCK_MESSAGE: Record<ProjectGeometryLock, string> = {
  calculation: 'drawings.lockedCalculation',
  autopositioning: 'drawings.lockedAutopositioning',
};

/** The version whose calculation locks the project's geometry (its name is shown in the explanation). */
export function lockingVersion(project: Pick<Project, 'versions'> | null | undefined) {
  return (project?.versions ?? []).find(calculated);
}
